export enum DisplayFormat {
    Desktop,
    Tablet,
    Mobile
}
